import { render, staticRenderFns } from "./WidgetWizard.vue?vue&type=template&id=ef8359e6"
import script from "./WidgetWizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetWizard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports